import React, { Component } from 'react';
import {Button} from 'reactstrap';
import { withCookies } from 'react-cookie';
import '../css/alum-style.css';
import './Home.css'
import MainLogoBeta from '../art/images/alumsumlogotm.png'


class Home extends Component {
    state = {
        isLoading: true,
        isAuthenticated: false,
        user: undefined,
        consent: false,
        verified: false
    };

    constructor(props) {
        super(props);
        const {cookies} = props;
        this.state.csrfToken = cookies.get('XSRF-TOKEN'); 
        this.login = this.login.bind(this);
        this.logout = this.logout.bind(this);
    }

    async componentDidMount() {
        const response = await fetch('/alumsum/reguser', {credentials: 'include'});
        const body = await response.text();
        if (body === '') {
            this.setState(({isAuthenticated: false}))
        } else {
            this.setState({isAuthenticated: true, user: JSON.parse(body).email, consent:JSON.parse(body).consent,
            verified:JSON.parse(body).verified})
        }

        await fetch('/alumsum/users', {credentials: 'include'})
            .then(async response => response.json())
            .then(data => this.setState({ info: data })
        );
        this.setState({email: this.state.info[0].userEmail});
        if (this.state.info[0].userAttributes === null || this.state.info[0].userEmail === null) {
            this.setState({url: '/alumsum/onboarding'});
        } else if (this.state.info[0].loanAggregations === null) {
            this.setState({url: '/alumsum/onboardingloansspinwheel'});
        } else {
            /* they will definitly have some personal information at this point */
            this.setState({url: '/alumsum/dashboard'});
        }
        console.log(this.state.url);
    }

    login() {
        let port = (window.location.port ? ':' + window.location.port : '');
        if (port === ':3000') {
            port = ':8080';
        }
        window.location.href = '//' + window.location.hostname + port + '/private';
    }

    logout() {
        fetch('/alumsum/logout', {method: 'POST', credentials: 'include',
            headers: {'X-XSRF-TOKEN': this.state.csrfToken}}).then(res => res.json())
            .then(response => {
                console.log(response);
                window.location.href = response.logoutUrl + "?id_token_hint=" +
                    response.idToken + "&post_logout_redirect_uri=" + window.location.origin;
            });
    }

    render() {
        var url = this.state.url;
        var email = this.state.user;
        var consent = this.state.consent;
        var verified = this.state.verified;
        console.log(email)
        const message = this.state.user ?
            <h2 className="welcomeUser">Welcome, {this.state.user}!</h2> :
            null;

        const buttonStyle = {
            backgroundColor: '#468674',
            padding: '1.35rem 0.85rem 0.75rem 0.85rem'
        };

        if(this.state.isAuthenticated) {
            if(!verified) {
                window.location.href = '/alumsum/email_verification';
            }
            else {
                if (!consent) {
                    window.location.href = '/alumsum/optin';
                } else{
                    if (email === null) {
                        window.location.href = '/alumsum/onboarding';
                    } else {
                        window.location.href = '/alumsum/dashboard';
                    }
                }
            }
        }

        const button =
            <div className="buttonDiv">
                <Button className="homeButton" onClick={this.login}>Customer Sign In</Button>
                <div className="inst">You will be redirected to Auth0 for authentication.
                </div>
            </div>;

        return (
            <div className="homeContainer">
                <div className="main-logo">
                            <img src={MainLogoBeta} alt="main logo" className="responsive"/>
                    <div className="loginbox">
                        <form>
                            {message}
                            {button}
                        </form>
                    </div>
                </div>
                    {/*<div className="loginbox">*/}
                    {/*    <form>*/}
                    {/*    {message}*/}
                    {/*    {button}*/}
                    {/*    </form>*/}
                    {/*</div>*/}
            </div>
        );
    }
}
export default withCookies(Home);